import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useClockifyStore = create()(
    persist(
        (set, get) => ({
            entries: [],
            activeEntry: null,
            isRunning: false,
            currentTask: '',
            projects: [
                { id: 'default', name: 'No Project', color: '#999999' }
            ],
            selectedProject: 'default',

            setCurrentTask: (task) => set({ currentTask: task }),

            setSelectedProject: (projectId) => set({ selectedProject: projectId }),

            addProject: (name, color) => {
                const newProject = {
                    id: crypto.randomUUID(),
                    name,
                    color,
                };
                set((state) => ({
                    projects: [...state.projects, newProject],
                }));
            },

            removeProject: (projectId) => {
                set((state) => ({
                    projects: state.projects.filter(p => p.id !== projectId),
                    entries: state.entries.map(e =>
                        e.projectId === projectId ? { ...e, projectId: 'default' } : e
                    ),
                    selectedProject: state.selectedProject === projectId ? 'default' : state.selectedProject,
                }));
            },

            startTimer: () => {
                const { currentTask, selectedProject } = get();
                const newEntry = {
                    id: crypto.randomUUID(),
                    task: currentTask.trim() || 'Untitled Task',
                    startTime: Date.now(),
                    endTime: null,
                    duration: null,
                    projectId: selectedProject,
                };
                set({ activeEntry: newEntry, isRunning: true, currentTask: '' });
            },

            stopTimer: () => {
                const { activeEntry, entries } = get();
                if (!activeEntry) return;

                const endTime = Date.now();
                const duration = endTime - activeEntry.startTime;

                const completedEntry = {
                    ...activeEntry,
                    endTime,
                    duration,
                };

                set({
                    entries: [completedEntry, ...entries],
                    activeEntry: null,
                    isRunning: false,
                });
            },

            updateEntry: (id, newStart, newEnd, newTask) => {
                set((state) => {
                    const updatedEntries = state.entries.map((e) =>
                        e.id === id
                            ? { ...e, startTime: newStart, endTime: newEnd, duration: newEnd - newStart, task: newTask || e.task }
                            : e
                    );

                    // If updating the active entry, update it too
                    const updatedActiveEntry = state.activeEntry?.id === id
                        ? { ...state.activeEntry, startTime: newStart, endTime: newEnd, task: newTask || state.activeEntry.task }
                        : state.activeEntry;

                    return {
                        entries: updatedEntries,
                        activeEntry: updatedActiveEntry
                    };
                });
            },

            deleteEntry: (id) =>
                set((state) => ({ entries: state.entries.filter((e) => e.id !== id) })),

            clearEntries: () =>
                set({ entries: [], activeEntry: null, isRunning: false }),
        }),
        {
            name: 'clockify-storage',
        }
    )
);
